import React, { useContext } from 'react'

import Wait from '@react/react-spectrum/Wait'

import { DialogProvider } from 'hooks'
import { RootContext } from 'root'

import Header from './partials/Header'
import Footer from './partials/Footer'
import ErrorBoundary from './partials/ErrorBoundary'
import ErrorMessage from './partials/ErrorMessage'

import './App.scss'

export default function App({ children }) {
  const { loading, error, user } = useContext(RootContext)

  if (loading) {
    return (
      <div className='app-wrapper'>
        <div className='wait-wrapper'>
          <Wait centered size='L' />
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className='app-wrapper'>
        <div className='error-wrapper'>
          <ErrorMessage error={error} />
        </div>
      </div>
    )
  }

  return (
    <div className='app-wrapper'>
      <ErrorBoundary>
        <DialogProvider>
          <Header currentUser={user} />
          <main>{children}</main>
          <Footer />
        </DialogProvider>
      </ErrorBoundary>
    </div>
  )
}
